<logout-splash></logout-splash>
